<svg
  [attr.viewBox]="viewBox"
  *ngIf="displayStyle === 'horizontal' || displayStyle === 'horizontal-all'"
  class="horizontalHolder"
>
  <g
    [matTooltip]="tooltipMessage"
    matTooltipShowDelay="100"
    matTooltipClass="multiline"
  >
    <rect
      [attr.x]="i * (this.pillWidth + this.pillGap)"
      y="0"
      [attr.width]="this.pillWidth"
      [attr.height]="this.pillWidth / 2"
      rx="3"
      ry="3"
      [ngClass]="pill.exists ? 'fullPill' : 'emptyPill'"
      *ngFor="let pill of pills; let i = index"
    ></rect>
  </g>
</svg>

<div
  *ngIf="displayStyle === 'round' || displayStyle === 'round-all'"
  class="roundHolder"
>
  <svg [attr.viewBox]="viewBox">
    <g
      [matTooltip]="tooltipMessage"
      matTooltipShowDelay="100"
      matTooltipClass="multiline"
    >
      <path
        *ngFor="let pill of pills"
        [attr.d]="pill.path"
        [ngClass]="pill.exists ? 'fullPill' : 'emptyPill'"
      />
    </g>
  </svg>
</div>
